import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../config/api";
import { Table, Alert, Spin, Tag } from "antd";

const PhoneNumberList = () => {
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPhoneNumbers = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(API_BASE_URL + "/phone-numbers", {
          headers: {
            Authorization: token,
          },
        });
        setPhoneNumbers(response.data);
      } catch (err) {
        setError("Failed to fetch phone numbers");
      } finally {
        setLoading(false);
      }
    };
    fetchPhoneNumbers();
  }, []);

  const columns = [
    {
      title: "Phone Number",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Label",
      dataIndex: "label",
      key: "label",
      render: (label) => label || "N/A",
    },
    {
      title: "Supports Inbound",
      dataIndex: "supports_inbound",
      key: "supports_inbound",
      render: (supports) =>
        supports ? <Tag color="green">YES</Tag> : <Tag color="red">NO</Tag>,
    },
    {
      title: "Supports Outbound",
      dataIndex: "supports_outbound",
      key: "supports_outbound",
      render: (supports) =>
        supports ? <Tag color="green">YES</Tag> : <Tag color="red">NO</Tag>,
    },
    {
      title: "Assigned Agent",
      dataIndex: "assigned_agent_name",
      key: "assigned_agent_name",
      render: (name) => name || "N/A",
    },
    {
      title: "Provider",
      dataIndex: "provider",
      key: "provider",
      render: (provider) => provider || "N/A",
    },
  ];

  return (
    <div className="container">
      <h2>Phone Numbers</h2>
      {error && (
        <Alert message={error} type="error" showIcon className="mb-4" />
      )}
      {loading ? (
        <Spin size="large" className="d-flex justify-content-center" />
      ) : phoneNumbers.length === 0 ? (
        <Alert message="No phone numbers found." type="info" showIcon />
      ) : (
        <Table
          className="hidden-scroll"
          scroll={{ y: 600 }}
          dataSource={phoneNumbers}
          columns={columns}
          rowKey="phone_number_id"
          bordered
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
          }}
        />
      )}
    </div>
  );
};

export default PhoneNumberList;
